import {computed, ref, type Ref} from 'vue'

const enabled: Ref<boolean> = ref(false)
const visible: Ref<boolean> = ref(false)

export function useBetDock() {
	function enable(): void {
		enabled.value = true
	}

	function disable(): void {
		enabled.value = false
	}
	
	function show(): void {
		visible.value = true
	}

	function hide(): void {
		visible.value = false
	}

	function toggle(): void {
		visible.value = !visible.value
	}

	const isVisible = computed(() => {
		return enabled.value && visible.value
	})


	return {
		isVisible,
		enable,
		disable,
		show,
		hide,
		toggle
	}
}